module.exports = __webpack_public_path__ + "sendview-logo-de3734e7ae566f1d83a268fb3fc9374e.png";